import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import MypageTextField from "../../../ui/MypageTextField";
import MypagePhoneNumTextField from "../../../ui/MypagePhoneNumTextField";
import Completion from "../common/Completion";
import {
  getMypageUser,
  postUpdateUserContacts,
} from "../../../../services/apiStudent";
import {
  validateEmailAddress,
  validateDifferentVal,
} from "../../../../utils/validate";

const UpdateContacts = () => {
  // 確認画面かどうかのフラグ
  const [isConfirmation, setIsConfirmation] = useState(false);
  // 完了画面かどうかのフラグ
  const [isCompFlg, setIsCompFlg] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  // 送信するボタン
  const onSubmit = async (data) => {
    if (isConfirmation) {
      // 確認画面のとき
      const json = await postUpdateUserContacts(data);
      if (json?.result) {
        setIsCompFlg(true);
        scrollTop();
      }
    } else {
      // 入力画面のとき
      setIsConfirmation(true);
      scrollTop();
    }
  };

  // 入力画面へ戻る
  const handleBackConfirmation = () => {
    setIsConfirmation(false);
    scrollTop();
  };

  // スクロールを一番上に移動
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  // 初回レンダリング
  useEffect(() => {
    (async function () {
      const data = await getMypageUser();
      if (data == undefined || !data) return;
      // 連絡先
      if (data) {
        setValue("phone1", data.phone1);
        setValue("mail1", data.mail1);
        setValue("updated_at1", data.contact_updated_at1);
        setValue("phone2", data.phone2);
        setValue("mail2", data.mail2);
        setValue("updated_at2", data.contact_updated_at2);
      }
    })();
  }, []);

  return (
    <>
      {isCompFlg ? (
        <Completion
          title="ユーザー情報の変更完了"
          explanation="ユーザー情報の変更を完了致しました。"
          link="/mypage/user"
          btntext="ユーザー情報の確認・変更ページに戻る"
        />
      ) : (
        <div className="l-page-right">
          <div className="l-page-con">
            <h1 className="p-heading01">
              {isConfirmation
                ? "ユーザー情報の変更内容確認"
                : "ユーザー情報変更"}
            </h1>
            <form className="p-login-form" onSubmit={handleSubmit(onSubmit)}>
              <div className="p-login-con__form">
                <MypagePhoneNumTextField
                  name="phone1"
                  label="電話番号1"
                  setValue={setValue}
                  register={register}
                  validation={{
                    ...validateDifferentVal("phone1", "phone2", "電話番号"),
                  }}
                  errors={errors}
                  watch={watch}
                  required={true}
                  placeholder="電話番号を入力してください"
                  isStatic={isConfirmation}
                />
                <MypageTextField
                  name="mail1"
                  label="メールアドレス1"
                  maxLength={100}
                  register={register}
                  validation={{
                    ...validateEmailAddress(),
                    ...validateDifferentVal("mail1", "mail2", "メールアドレス"),
                  }}
                  errors={errors}
                  watch={watch}
                  placeholder="メールアドレスを入力してください"
                  isStatic={isConfirmation}
                />
                <MypagePhoneNumTextField
                  name="phone2"
                  label="電話番号2"
                  setValue={setValue}
                  register={register}
                  validation={{
                    ...validateDifferentVal("phone1", "phone2", "電話番号"),
                  }}
                  errors={errors}
                  watch={watch}
                  placeholder="電話番号を入力してください"
                  isStatic={isConfirmation}
                />
                <MypageTextField
                  name="mail2"
                  label="メールアドレス2"
                  maxLength={100}
                  register={register}
                  validation={{
                    ...validateEmailAddress(),
                    ...validateDifferentVal("mail1", "mail2", "メールアドレス"),
                  }}
                  errors={errors}
                  watch={watch}
                  placeholder="メールアドレスを入力してください"
                  isStatic={isConfirmation}
                />
                <div hidden>
                  <input
                    type="text"
                    name="updated_at1"
                    {...register("updated_at1")}
                  />
                  <input
                    type="text"
                    name="updated_at2"
                    {...register("updated_at2")}
                  />
                </div>
                <div className="p-login-form__btnbox">
                  <div className="p-login-form__returnbtn">
                    {isConfirmation ? (
                      <input
                        className="p-login-form__link"
                        type="button"
                        value="変更ページへ戻る"
                        onClick={() => handleBackConfirmation()}
                      />
                    ) : (
                      <Link to="/mypage/user">
                        <input
                          className="p-login-form__link"
                          type="button"
                          value="変更を取り消す"
                        />
                      </Link>
                    )}
                  </div>
                  <div className="p-login-form__send">
                    <input
                      className="p-login-form__link"
                      type="submit"
                      value={
                        isConfirmation ? "変更を確定する" : "変更内容を確認する"
                      }
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default UpdateContacts;
